import React from "react";
import ColorGroup from "./color-group";

interface Color {
  bgClass: string;
  hexColor: string;
}

interface ColorPaletteProps {
  background: string;
  colors: Color[];
}

const ColorPalette: React.FC<ColorPaletteProps> = ({ background, colors }) => {
  return (
    <div
      className="relative w-full bg-cover bg-center p-5 mb-5 flex flex-wrap"
      style={{ backgroundImage: `url(${background})` }}
    >
      <div className="absolute inset-0 bg-black opacity-30"></div>
      {colors.map((color, index) => (
        <ColorGroup key={index} bgClass={color.bgClass} hexColor={color.hexColor} />
      ))}
    </div>
  );
};

export default ColorPalette;
